import { render } from "./ContactsButton.vue?vue&type=template&id=7b5d6dec&scoped=true"
import script from "./ContactsButton.vue?vue&type=script&lang=js"
export * from "./ContactsButton.vue?vue&type=script&lang=js"

import "./ContactsButton.vue?vue&type=style&index=0&id=7b5d6dec&lang=scss&scoped=true"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5d6dec"]])

export default __exports__